module.exports = __webpack_public_path__ + "media/applicants/schedule-shift-d178db69.svg";